import { useContext } from "react"
import { AuthContext } from "../context/auth"

export default function useFolderPermissions() {
    const { folderPermissions, setFolderPermissions } = useContext(AuthContext)

    return { folderPermissions, setFolderPermissions }
}
